import React from 'react'

function Details() {
  return (
    <div className="built-with-section mb-5">
			<div className="container">
				<div className="row justify-content-center align-items-start">
					<div className="col-lg-6">
						<div className='text-left'>
                            <h3 className="section-title tools-title">Tools :</h3>
                            <ul className='tools-ul'>
                                <li><strong>Tech Stack:</strong> ReactJS, React Router DOM</li>
                                <li><strong>CSS Framework:</strong> Bootstrap v5.1.3</li>
                                <li><strong>State Management:</strong> Context API</li>
								<li><strong>API Endpoint:</strong> JavaScript Buy SDK (Shopify)</li>
                            </ul>
                        </div>
						<div className='text-left'>
                            <h3 className="section-title tools-title">Summary :</h3>
                            <p className='summary-wrap'>								
								Developed a headless CMS using ReactJS in conjunction with the Shopify JavaScript Buy SDK. The frontend boasts a responsive design crafted with Bootstrap, ensuring an optimal user experience across devices. To maintain a seamless data flow, I implemented React Context for efficient state management. Users can effortlessly add products to their carts, adjust quantities, and remove items as needed. Upon proceeding to checkout, users are seamlessly redirected to Shopify's checkout page for a streamlined purchasing process. Through integration with Shopify API endpoints, the application dynamically updates product data in real-time, responding swiftly to user interactions and requests.
							</p>
                        </div>
					</div>

					<div className="col-lg-6">
						<div className="img-wrap">
							<img src={require('../assets/images/rs-logo.jpg')}  alt="Image" className="img-fluid rs-img" />
						</div>
					</div>

				</div>
			</div>
		</div>
  )
}

export default Details